import React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { spring } from '../../utils/motion';
interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
}
export function Switch({
  checked,
  onChange,
  label,
  description
}: SwitchProps) {
  return <label className="flex cursor-pointer items-center justify-between gap-4" data-id="element-838" data-mp="2iror0zl2ad1b">
      <span data-id="element-839" data-mp="36hj5fll149no">
        <span className="block text-[15px] font-bold" data-id="element-840" data-mp="36hsv1825wesu">{label}</span>
        {description && <span className="mt-0.5 block text-sm text-ink-3" data-id="element-841" data-mp="3bfknq4ams4y3">{description}</span>}
      </span>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={twMerge('relative h-8 w-[52px] shrink-0 rounded-full p-1 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-bg', checked ? 'bg-ink' : 'bg-line', checked ? 'flex justify-end' : 'flex justify-start')} data-id="element-842" data-mp="2wqg3yio6tsnv">
        <motion.span layout transition={spring.snappy} className="block h-6 w-6 rounded-full bg-bg shadow-sm" data-id="element-843" data-mp="22y1pbalh6jdx" />
      </button>
    </label>;
}